import React from "react"
import {connect, Provider} from "react-redux"
import store from "../store";

import {
    css,
    modal,
    Theme,
} from "@bdfx/mergado-ui-kit";
import {isGodModeOn, setFirstStepsWizard} from "app/helpers/api";
import {RouterType, withRouter} from "app/components/routes";
import Content from "./content";
import { initForm } from "app/reducers/form"

interface Props {
    showFirstSteps: number
    router: RouterType
    initForm: typeof initForm
}

class FirstStepsModal extends React.Component<Props> {
    constructor(props) {
        super(props)
    }

    showModal = () => {
        modal({
            closeOnEscape: false,
            closeOnClickOutside: false,
            fullscreen: true,
            hideCloseButton: true,
            message: (close) => <Provider store={store}>
                <Content close={close} router={this.props.router} />
            </Provider>
        })
    }

    componentDidMount() {
        const {showFirstSteps} = this.props
        if (showFirstSteps && !isGodModeOn) {
            this.showModal()
        }
    }

    hideFirstSteps = () : boolean => {
        return !!setFirstStepsWizard(0)
    }

    render() {
        return false
    }
}

const Header = css("div")({
    textAlign: "center",
    lineHeight: "1.25em",
    textTransform: "uppercase",
    color: Theme.blue,
    " .muk-icon": {
        display: "block",
        padding: "5px",
    }
})

function mapStateToProps(state, props) {
    return {
    }
}

export default connect(mapStateToProps, {
    initForm,
})(withRouter(FirstStepsModal));